import { useEffect, useState } from 'react';
import { getGameFromUrl } from '@core/utils/urlParser';
import { isSkyxNewRoute } from '@core/utils/gameRouteSlugs';
import { track } from '@core/analytics';

export const SKYX_NEW_GAME_READY_CLASS = 'skyx-new-game-ready';

export function clearSkyxNewGameReady(): void {
  document.body.classList.remove(SKYX_NEW_GAME_READY_CLASS);
}

export function markSkyxNewGameReady(slug?: string | null): void {
  const game = slug ?? getGameFromUrl();
  if (isSkyxNewRoute(game)) {
    const alreadyReady = isSkyxNewGameReady();
    document.body.classList.add(SKYX_NEW_GAME_READY_CLASS);
    if (!alreadyReady) {
      track('intro_closed');
    }
  }
}

export function isSkyxNewGameReady(): boolean {
  return document.body.classList.contains(SKYX_NEW_GAME_READY_CLASS);
}

/** Reactive skyx_new bootstrap / preloader gate (body `skyx-new-game-ready` class). */
export function useSkyxNewGameReadyState(): boolean {
  const [ready, setReady] = useState(isSkyxNewGameReady);

  useEffect(() => {
    const syncReadyState = () => {
      setReady(isSkyxNewGameReady());
    };

    syncReadyState();
    const observer = new MutationObserver(syncReadyState);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });

    return () => observer.disconnect();
  }, []);

  return ready;
}
